import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { useUser } from '../hooks/useUser.jsx';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import '../styles/Login.css';
import { ErrorMessage } from '../components/commons/ErrorMessage.jsx';
import ReCAPTCHA from "react-google-recaptcha";
import { TextFieldRequired } from '../components/commons/TextFieldRequired.jsx';

export function Login() {
    const { login, isLogged, loginError, errorType, getURLs } = useUser();
    const navigate = useNavigate();
    const { t, i18n, ready } = useTranslation()
    const [openDialogError, setOpenDialogError] = useState(false);
    const [usuariosURL, setUsuariosURL] = useState();
    const recaptchaRef = useRef(null);
    const [fallos, setFallos] = useState(0);

    const {
        //Maneja los campos del form y sus estados
        control,
        //Maneja la presentacion del formulario
        handleSubmit,
    } = useForm();

    useEffect(() => {
        if (isLogged) {
            localStorage.removeItem("UserLogInErrorCount");
            navigate('/MisCuestionarios')
        }
        var urlPromise = getURLs()
            .then((x) => {
                setUsuariosURL(x.usuario);
            });
        setOpenDialogError(loginError);
        if (localStorage.getItem("UserLogInErrorCount") != null && localStorage.getItem("UserLogInErrorCount") != fallos) {
            setFallos(parseInt(localStorage.getItem("UserLogInErrorCount")));
        }
    }, [isLogged, navigate, loginError])

    const handleClose = () => {
        setOpenDialogError(false);
    }

    function handleRecaptcha() {
        if (recaptchaRef.current.getValue()) {

        }
    }


    const onSubmit = (data) => {
        if (fallos < 3 || recaptchaRef.current.getValue())
            login(data.username, data.password)
        if (!isLogged) {
            localStorage.setItem("UserLogInErrorCount", fallos + 1);
            if (fallos > 3)
                recaptchaRef.current.reset();
        }
    };
    

    return (
        
        <Container className='container'>
            <Grid
                container direction="row"
                justifyContent="center"
                alignItems="center"
                className='login-container'>
                <Grid item xs={12} lg={6} className='signIn'>
                    <Stack spacing={4}>
                        <Typography variant="h3" className='montserratBold'>
                            {t('login.saludoPYME')}
                        </Typography>
                        <Typography variant="p" style={{ display: 'block' }}>
                            {t('login.textoPYME')}
                        </Typography>
                        {usuariosURL &&
                            <Link href={usuariosURL.registro} target="_blank" sx={{ textDecoration: 'none' }}>
                                <Button variant="contained" type="submit">{t('login.registrarse')}</Button>
                            </Link>
                        }
                    </Stack>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <form className='form' onSubmit={handleSubmit(onSubmit)}>
                        <Stack spacing={4} className='logIn'>
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="h5" className='montserratBold, loginTitle'>
                                    {t('login.titulo')}
                                </Typography>
                            </Box>
                            <TextFieldRequired
                                control={control}
                                label={t("login.labelUsuario")}
                                name="username"
                            />
                            <TextFieldRequired
                                control={control}
                                label={t("login.labelContrasenia")}
                                name={"password"}
                                type='password'
                            />
                            {usuariosURL &&
                                <Link href={usuariosURL.olvidoPassword} target="_blank" style={{ paddingTop: '2em', margin: '0 auto' }}>
                                    {t('login.linkContrasenyaOlvidada')}
                                </Link>
                            }
                            {fallos >= 3 &&
                                <Box style={{margin: '0 auto', paddingTop: '2em'}}>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_API_KEY}
                                        onChange={handleRecaptcha}
                                    />
                                </Box>
                            }
                            <Button
                                 data-callback='onSubmit' data-action='submit' variant="contained" type="submit" className='buttonAcceder'>{t('login.botonAcceder')}</Button>
                        </Stack>
                    </form>

                </Grid>
                {openDialogError &&
                    <ErrorMessage showDialogError={openDialogError} errorDialogTitle={"login.errorDialogTitle"} errorType={"login." + errorType} handleClose={handleClose} />
                }
            </Grid>
        </Container>
    )
}